import Digirep from "../../../jsx/components/Dashboard/Digirep/Digirep";

const DigirepWrapper = () => {
  return <Digirep />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(DigirepWrapper);
